module.exports = __webpack_public_path__ + "img/cross1red.4a1a0abb.png";